export const formattedSort = <T>(a: T, b: T, direction: 'asc' | 'desc') => {
  const [arg1, arg2] = [
    typeof a === 'string' ? (a as string).toLowerCase() : a,
    typeof b === 'string' ? (b as string).toLowerCase() : b,
  ];
  if (arg1 > arg2) {
    return direction === 'asc' ? 1 : -1;
  }
  return direction === 'asc' ? -1 : 1;
};

export const sortTableData = <T>(
  data: T[],
  sortKey: keyof T,
  direction: 'asc' | 'desc',
) => {
  return data.sort((a, b) => formattedSort(a[sortKey], b[sortKey], direction));
};
